import React from 'react';
import {
  franceDeleteRequest,
  franceDIDAssign,
  getFranceRequestedList,
} from '../../../api-services';
import { useMutation, useQueryClient } from 'react-query';
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faEllipsisV,
  faShuffle,
  faFile,
} from '@fortawesome/free-solid-svg-icons';
import TableManager from '../../../components/TableManager';
import { createTable } from '@tanstack/react-table';
import { useState } from 'react';
import KycModal from './KycModal';
import { useDispatch } from 'react-redux';
import { openUserDetailsModal } from '../../../redux/features/modalSlice';

const table = createTable();

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const statusOptions = [
  { label: 'Active', value: 'A' },
  { label: 'Deactive', value: 'D' },
];
const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];

const currencyOptions = [
  { label: 'EURO', value: 'EURO' },
  { label: 'XOF', value: 'XOF' },
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'NGN', value: 'NGN' },
];

const initialValues = {
  filter: [
    {
      did_number: '',
      a_filter_type: '',
      placeholder: 'Enter Did Number...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'Did Number',
    },
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      currency: '',
      a_filter_type: '',
      placeholder: 'Select Currency...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: currencyOptions,
      label: 'Currency',
    },

    {
      did_city: '',
      a_filter_type: '',
      placeholder: 'Enter City...',
      type: 'text',
      shouldFilterOptionDisabled: true,
      label: 'City',
    },
    {
      did_status: '',
      a_filter_type: '',
      placeholder: 'Select Status...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: statusOptions,
      label: 'Status',
    },

    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Select Buy Date...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Buy Date',
    },
  ],
};

const RequestFrance = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [viewKyc, setviewKyc] = useState(false);
  const [kycData, setkycData] = useState({});
  const { mutateAsync: mutateAsyncdelete } = useMutation(
    'franceDeleteRequest',
    franceDeleteRequest,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('getFranceRequestedList');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );
  const { mutateAsync: mutateAsyncAssign } = useMutation(
    'franceDIDAssign',
    franceDIDAssign,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('getFranceRequestedList');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleDeleteNumber = (val) => {
    swal({
      text: 'Are you sure you want to delete this request?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            id: val?.id,
          };
          await mutateAsyncdelete(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };
  const handleNumberAssign = (val) => {
    swal({
      text: 'Are you sure you want to assign this number?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            id: val?.id,
          };
          await mutateAsyncAssign(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const handleStatus = (val) => {
    switch (val) {
      case 'A':
        return 'Assigned';
      case 'P':
        return 'Pending';
      case 'U':
        return 'Used';
      case 'R':
        return 'Under Review';
      case 'D':
        return 'Disapproved';
      default:
        return '---';
    }
  };

  const handleViewKYC = (val) => {
    setkycData(val);
    setviewKyc(true);
  };

  const handleOpenUserDetails = (shouldOpen, data) => {
    if (!shouldOpen) {
      return false;
    }

    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Request Date',
      textAlign: 'left',
      isSortable: true,
    }),
    table.createDataColumn((row) => row?.customer?.msisdn, {
      id: 'msisdn',
      header: 'MSISDN',
      textAlign: 'left',
      shouldPointer: true,
      cell: (props) => (
        <span
          className="hover-name"
          onClick={() =>
            handleOpenUserDetails(
              props.getValue(),
              props?.row?.original?.customer,
            )
          }
        >
          {props.getValue()}
        </span>
      ),
    }),

    table.createDataColumn('did_number', {
      id: 'did_number',
      header: 'DID Number',
      textAlign: 'left',
    }),

    table.createDataColumn('period', {
      id: 'period',
      header: 'Period',
      isSortable: true,
    }),
    table.createDataColumn('amount', {
      id: 'amount',
      header: 'Amount',
      isSortable: true,
    }),
    table.createDataColumn('currency', {
      id: 'currency',
      header: 'Currency',
    }),
    table.createDataColumn('type', {
      id: 'type',
      header: 'Type',
    }),
    table.createDataColumn('user_city', {
      id: 'user_city',
      header: ' User City',
    }),

    table.createDataColumn('assign_at', {
      id: 'assign_at',
      header: 'Assign at',
    }),
    table.createDataColumn('status', {
      id: 'status',
      header: 'Status',
      cell: (props) => handleStatus(props.getValue()),
    }),
    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleViewKYC(props.row.original)}
              >
                <FontAwesomeIcon icon={faFile} />
                View KYC
              </Dropdown.Item>
              {props.row?.original?.status === 'P' && (
                <Dropdown.Item
                  href={void 0}
                  onClick={() => handleNumberAssign(props.row.original)}
                >
                  <FontAwesomeIcon icon={faShuffle} />
                  Assign
                </Dropdown.Item>
              )}

              <Dropdown.Item
                href={void 0}
                onClick={() => handleDeleteNumber(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="getFranceRequestedList"
        fetcherFn={getFranceRequestedList}
        title="Requested DID"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
      />
      {viewKyc && (
        <KycModal
          viewKyc={viewKyc}
          kycData={kycData}
          setviewKyc={setviewKyc}
          setkycData={setkycData}
        />
      )}
    </>
  );
};

export default RequestFrance;
